exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reminder-wrapper p{font-size:16px;text-align:center}", ""]);

